module.exports = __webpack_public_path__ + "static/media/maintenance.337070a6.png";